import { de } from "./de" 
import { enus } from "./en-US" 
import { esar } from "./es-AR" 
import { heil } from "./he-IL" 
import { pl } from "./pl" 
import { pt } from "./pt" 
import { ptbr } from "./pt-BR" 
import { ru } from "./ru" 
import { ukua } from "./uk-UA" 

export const mobileResources = {
	"de": de, 
	"en-US": enus, 
	"es-AR": esar, 
	"he-IL": heil, 
	"pl": pl, 
	"pt": pt, 
	"pt-BR": ptbr, 
	"ru": ru, 
	"uk-UA": ukua, 
}